export const environment = {
  production: true,
  apiEndpoint: 'https://testbackend.tupelolife.health',
  appEndpoints: {
    patient: 'https://testapp.tupelolife.health',
    provider: 'https://testprovider.tupelolife.health',
    careteam: 'https://testcareteam.tupelolife.health',
    home_health: 'https://testhomehealth.tupelolife.health',
    admin: 'https://testadmin.tupelolife.health',
    super_admin: 'https://testsuperadmin.tupelolife.health',
    super_super_admin: 'https://testssadmin.tupelolife.health'
  },
  pubnub: {
    publishKey: 'pub-c-0876794c-3d83-41ea-9339-649fe5d02dae',
    subscribeKey: 'sub-c-f1a41266-a5bd-11eb-b65a-ce685c2f57ca',
  },
};
